import { GET_ALL_CAT_DOCUMENTS } from "../constants/endpoints";
import axiosClient from "./axios";

class catalogService {
  static async fetchAllCatDoc(
    page: number,
    limit: number,
    status: string,
    barcode: string,
    domain: string,
    isApproved: boolean,
    createdBy: string,
    createdAt: string,
    modifiedAt: string,
    productName: string
  ) {
    const filters = {
      status: status !== null ? status : undefined,
      barcode: barcode !== null ? barcode : undefined,
      domain: domain !== null ? domain : undefined,
      isApproved: isApproved !== null ? isApproved : undefined,
      createdBy: createdBy !== null ? createdBy : undefined,
      productName: productName !== null ? productName : undefined,
    };
    const sort = {
      createdAt: createdAt !== null ? createdAt : undefined,
      modifiedAt: modifiedAt !== null ? modifiedAt : undefined,
    };
    const response = await axiosClient.post(GET_ALL_CAT_DOCUMENTS, {
      page: page,
      limit: limit,
      filters: filters,
      sort: sort,
    });
    return response;
  }
}

export default catalogService;
